export interface SiteGroupIdentity {
  siteId?: string | null
  siteName?: string | null
  siteSlug?: string | null
  corporateId?: string | null
}

export interface SentSiteGroup {
  siteId: string | null
  corporateId: string | null
}

/**
 * After a page refresh the site is restored before the brand has loaded, so the site is sent
 * once without a brand and must be sent again when the brand arrives. Sending it only when the
 * site changed left the brand blank for the whole visit (OC-1231).
 */
export const shouldSendSiteGroup = (
  identity: SiteGroupIdentity,
  lastSent: SentSiteGroup
): boolean => {
  if (!identity.siteId) {
    return false
  }
  if (identity.siteId !== lastSent.siteId) {
    return true
  }
  return Boolean(identity.corporateId) && identity.corporateId !== lastSent.corporateId
}

/**
 * The brand is omitted rather than sent empty: posthog-js saves group properties in PostHog and
 * also evaluates flags against them, so an empty `corporate_id` overwrites the real one instead
 * of being ignored.
 */
export const buildSiteGroupProperties = (identity: SiteGroupIdentity): Record<string, unknown> => ({
  name: identity.siteName,
  slug: identity.siteSlug,
  ...(identity.corporateId ? { corporate_id: identity.corporateId } : {}),
})
